export default "__VITE_ASSET__BMWKY$1s__"